import { render } from "./CommunicationList.vue?vue&type=template&id=369796d6&ts=true"
import script from "./CommunicationList.vue?vue&type=script&lang=ts"
export * from "./CommunicationList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__